import { FunctionComponent } from 'react'
import styled from 'styled-components'
import { PromoIndicatorProps } from '@widgets/Teaser/toi/types'
import SpecialPromoLine from './SpecialPromoLine'
import PromoLine from './PromoLine'

const StyledPromoIndicator = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

const PromoIndicator: FunctionComponent<PromoIndicatorProps> = ({
  children,
}) => (
  <StyledPromoIndicator>
    <SpecialPromoLine>{children}</SpecialPromoLine>
    <PromoLine lineOrientation="right" />
    <PromoLine lineOrientation="bottom" />
    <PromoLine lineOrientation="left" />
  </StyledPromoIndicator>
)

export default PromoIndicator
